//@flow
import React from 'react';
import Link from 'next/link';
import { PrismicGrantItem } from '../../types/prismic';
import FixedRatioImage from '../base/FixedRatioImage';
import styles from './grant-block.module.scss';
import { RichText } from 'prismic-reactjs';

type Props = {
  id: string;
  item: PrismicGrantItem;
  isTouch?: boolean;
};

const GrantBlock = ({ id, item, isTouch }: Props) => {
  const {
    award_process_active,
    cta_short,
    header_image,
    header_label,
    url_slug,
  } = item.data;
  const href = url_slug ?? '';

  if (isTouch) {
    return (
      <Link href={href}>
        <a className={styles.thumb} data-category={id}>
          <FixedRatioImage
            image={header_image.url}
            ratio="16x9"
            interactive={true}
          />
          <p className={styles.label}>{header_label}</p>
          <RichText render={cta_short} />
          <button className={`button small primary no-arrow`}>
            {award_process_active ? 'Apply Now' : 'Application Closed'}
          </button>
        </a>
      </Link>
    );
  }

  return (
    <a href={href} className={styles.thumb} data-category={id}>
      <FixedRatioImage
        image={header_image.url}
        ratio="16x9"
        interactive={true}
      />
      <p className={styles.label}>{header_label}</p>
      <RichText render={cta_short} />
      <button className={`button small primary no-arrow`}>
        {award_process_active ? 'Apply Now' : 'Application Closed'}
      </button>
    </a>
  );
};

export default GrantBlock;
